import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import ConfigProvider from '../config-provider';

class Link extends React.Component {
  static propTypes = {
    prefix: PropTypes.string,
    type: PropTypes.oneOf(['normal', 'primary']),
    href: PropTypes.string,
    target: PropTypes.string,
    /**
     * 自定义类名
     */
    className: PropTypes.string,
    /**
     * 自定义内敛样式
     */
    style: PropTypes.object,
  }

  static defaultProps = {
    prefix: 'next-',
    type: 'primary',
  }

  render() {
    const { prefix, type, href, target, className, style, children, ...others } = this.props;

    const linkCls = classNames({
      [`${prefix}link`]: true,
      [`${prefix}link-${type}`]: type,
      [className]: !!className,
    });

    return (
      <a
        className={linkCls}
        href={href}
        target={target}
        style={style}
        {...others}
      >
        {children}
      </a>
    );
  }
}

export default ConfigProvider.config(Link);
